export default [
  6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 8, 8, 9, 9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 22, 24, 26,
  28, 31, 33, 36, 40, 43, 46, 51, 54, 57, 60, 63, 65, 66, 67, 67, 67, 67, 67, 65, 64, 62, 60, 57,
  54, 51, 49, 46, 44, 41, 39, 37, 35, 33, 31, 29, 28, 26, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15,
  14, 13, 12, 11, 11, 10, 10, 9, 9, 8, 7, 6, 6, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
];
